<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 col-lg-8 mb-3">
					<div class="item-box">
						<h3 class="item-title">
							關於
						</h3>
						<p>
							本站《蘭德索爾圖書館》為推廣手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資料分享與轉蛋模擬器的網站。<br>資料內容以臺版《超異域公主連結☆Re:Dive》為主。
						</p>
						<p>
							本站使用Vue.js製作。
						</p>
						<p>
							本站為粉絲自製與 Cygames , So-net皆無任何關係
						</p>
						<p>
							本網站使用的遊戲圖像的版權，商標權和其他知識產權屬於原內容提供者(So-net Taiwan, Cygames)。
						</p>
						<p>
							對網站有任何問題請來信 , Name: Blanc , Mail: <a
								href="mailto:blblanc2212@gmail.com">blblanc2212@gmail.com</a>
						</p>
						<p>
							如有網站內容有問題可使用下表單，謝謝。
						</p>
						<p>
							If you have any questions about the website, please use the google form below, thank you.
						</p>
						<iframe
							src="https://docs.google.com/forms/d/e/1FAIpQLScFi_6vyyZSaIoKu9nh9TikeAQL_9nvV-XJP5rM4akIb2DBog/viewform?embedded=true"
							width="100%" height="750" frameborder="0" marginheight="0" marginwidth="0">載入中…</iframe>
					</div>
				</div>
				<div class="col-lg-4 col-12">
					<div class="item-box">
						<div class="row">
							<div class="col-12 my-3">
								{{ $t('DonateCap') }}<br>
							</div>
							<div class="col text-center">
								<a class="donate" href="https://qr.opay.tw/0DVjz" target="_blank">
									<img width="50" src="/static/images/opay.png" alt="opay" class="img-fluid">
								</a>
							</div>
							<div class="col text-center">
								<a href="https://paypal.me/Blblanc" target="_blank">
									<img width="60" src="/static/images/paypal.png" alt="paypal" class="img-fluid">
								</a>
							</div>
							<div class="col">
								<a href='https://ko-fi.com/I2I1VCXVX' target='_blank'><img height='36'
										style='border:0px;height:36px;'
										src='https://storage.ko-fi.com/cdn/kofi2.png?v=3' border='0'
										alt='Buy Me a Coffee at ko-fi.com' /></a>
							</div>
							<div class="col-12 text-center mt-3">
								<router-link :to="{ name: 'Donors' }">
									<a href="#">{{ $t('Donors') }}</a>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'About',
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '關於本站',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	data() {
		return {
			donateList: []
		}
	},
	computed: {},
	methods: {
		getDonateList: function (value) {
			var self = this;
			axios.get('/static/data/donate.json')
				.then(function (response) {
					self.donateList = response.data;
				});
		},
	},
	created: function () {
		this.getDonateList();
	},
	mounted: function () { }
}
</script>

<style scoped></style>